const trimTrailingSlash = (value) => String(value || '').trim().replace(/\/+$/, '');
const trimLeadingSlash = (value) => String(value || '').trim().replace(/^\/+/, '');
const isAbsoluteUrl = (value) => /^(https?:)?\/\//i.test(String(value || '').trim());
const stripApiSuffix = (value) => trimTrailingSlash(value).replace(/\/api\/admin$/i, '').replace(/\/api$/i, '');

const PRODUCTION_API_ORIGIN = "https://api.filazerobrasil.com.br";

export const ADMIN_API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === "development"
      ? "/api/admin"
      : `${PRODUCTION_API_ORIGIN}/api/admin`)
);

export const SOCKET_URL = trimTrailingSlash(
  process.env.REACT_APP_SOCKET_URL ||
    (process.env.NODE_ENV === "development" ? "" : PRODUCTION_API_ORIGIN)
);

export const UPLOADS_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_UPLOADS_BASE_URL || `${stripApiSuffix(ADMIN_API_BASE_URL)}/uploads`
);

export const STATIC_ASSETS_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_STATIC_ASSETS_URL || "https://static.filazerobrasil.com.br/painel"
);

export const buildStaticAssetUrl = (fileName) => {
  const file = trimLeadingSlash(String(fileName || "").trim());
  if (!file) return STATIC_ASSETS_BASE_URL;
  return `${STATIC_ASSETS_BASE_URL}/${file}`;
};

export const BRAND_LOGO_MARK_URL = buildStaticAssetUrl("filazero-admin-mark-blue.png");
export const BRAND_LOGO_ICON_192_URL = buildStaticAssetUrl("filazero-admin-mark-blue-192.png");
export const BRAND_LOGO_ICON_512_URL = buildStaticAssetUrl("filazero-admin-mark-blue-512.png");

export const buildUploadUrl = (filePath) => {
  const rawPath = String(filePath || '').trim();
  if (!rawPath) return '';
  if (isAbsoluteUrl(rawPath) || rawPath.startsWith('data:') || rawPath.startsWith('blob:')) {
    return rawPath;
  }
  const sanitizedPath = trimLeadingSlash(rawPath).replace(/^uploads\//i, '');
  return `${UPLOADS_BASE_URL}/${sanitizedPath}`;
};